<template>
  <div :class="isBlue ? 'trivago-link-blue' : 'trivago-link'">
    <a
      @click="handleTracking"
      :href="`https://www.trivago.com/${platformsLanguages[language]}/srl?search=100-${selectedAccommodationId}`"
      target="_blank"
      class="tw:hover:cursor-pointer tw:flex tw:items-center tw:text-gray-800 tw:relative tw:text-base tw:md:text-sm tw:h-full tw:w-full tw:md:w-auto tw:hover:text-blue-700"
      dataTestId="trivago-property-link"
    >
      <span>{{ $t('tbs_property_link_trivago') }}</span>
      <NewTab class="tw:fill-none tw:ml-2 tw:stroke-gray-800 tw:mx-4 tw:md:mr-0 tw:size-6" />
    </a>
  </div>
</template>
<script setup>
import NewTab from '@/components/icons/NewTab.svg?component'

import { platformsLanguages } from '@/constants/platformLanguages.ts'
import { selectedAccommodationId } from '@/layouts/queries'
import { useSessionValues } from '@/composables/useSessionValues'

import appAnalytics from '@/utils/tracking'

const props = defineProps({
  isBlue: {
    type: Boolean,
    default: false,
  },
  source: String,
})
const { language } = useSessionValues()
const handleTracking = () => {
  appAnalytics.track(appAnalytics.events.PD_CHECK_PROPERTY_LINK_CLICKED, {
    accommodationId: selectedAccommodationId.value,
    source: props.source,
  })
}
</script>
<style scoped>
.trivago-link:hover svg,
.trivago-link a:hover > svg,
.trivago-link:hover a,
.trivago-link a svg:hover {
  stroke: var(--tw-color-blue-700);
  color: var(--tw-color-blue-700);
  text-decoration: underline;
}

.trivago-link-blue a,
.trivago-link-blue svg {
  stroke: var(--tw-color-blue-700);
  color: var(--tw-color-blue-700);
}
</style>
